import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions } from 'api';
import { getKPIIndicatorListNotDeleted } from 'pages/PageKPIIndicatorList/api';
import { getKPITypeAvailableColumns } from './api';
import { EKPITypes } from './interfaces';

export const path = '/kpi-type/list';

const PageKPIType: React.FC = (props) => {
  const KPIType = Loadable.Map({
    loader: {
      page: () => import('./page'),
      kpiIndicators: getKPIIndicatorListNotDeleted,
      positions: getPositions,
      columns: () => getKPITypeAvailableColumns(EKPITypes.HOUSE),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <KPIType {...props} />;
};

export default PageKPIType;
